import { useCallback } from 'react';

const DEFAULT_MAX_FONT_SIZE = 14;
const DEFAULT_MIN_FONT_SIZE = 9;

/**
 * Returns a callback ref that shrinks the element's font size until its text
 * fits within the parent's bounds without overflow.
 *
 * Allows natural word-wrap — only reduces font size when the text still
 * overflows vertically after wrapping.
 */
export function useFitText(maxFontSize = DEFAULT_MAX_FONT_SIZE, minFontSize = DEFAULT_MIN_FONT_SIZE) {
  return useCallback(
    (el: HTMLElement | null) => {
      if (!el?.parentElement) return;
      const containerWidth = el.parentElement.clientWidth;
      let fontSize = maxFontSize;
      el.style.fontSize = `${fontSize}px`;
      while (el.scrollWidth > containerWidth && fontSize > minFontSize) {
        fontSize -= 0.5;
        el.style.fontSize = `${fontSize}px`;
      }
    },
    [maxFontSize, minFontSize],
  );
}
